<template>
<div>

    <v-dialog v-model="dialog" persistent scrollable fullscreen>
        <v-card>
            <v-card-title class="text-h5 pl-6 font-weight-regular">{{id?'Edit':'Add'}} Purchase Request
                <v-spacer/> <div class="requested-date"><span>Request Date :</span> {{moment(form.requestedDate).format('DD-MM-YYYY')}}</div>
                <v-btn icon @click="onCloseDialog"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title><v-divider/>
            <v-progress-linear :active="$apollo.queries.PurchaseRequest.loading" :indeterminate="true"/>
            <v-card-text class="mt-4">
                <v-form ref="form">
                    <v-row>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Product Name*</label>
                            <v-autocomplete outlined :items="products" :search-input.sync="searchProduct" clearable return-object
                                        v-model="selectedProduct" item-text="name" @change="onChangeProduct"
                                        :loading="$apollo.queries.products.loading" no-filter :rules="[v => !!v || 'Product Name required']">
                                <template v-slot:item="{item}">
                                    <v-list-item-avatar><img :src="imgWpx(item.Attachments[0].path, 200)" v-if="item.Attachments.length"></v-list-item-avatar>
                                    <v-list-item-content><v-list-item-title v-html="item.name"/></v-list-item-content>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Vendor Name*</label>
                            <v-autocomplete outlined :items="vendors" :search-input.sync="searchVendor" clearable return-object
                                            v-model="selectedVendor" no-filter item-text="name" @change="onchangeVendor"
                                            :loading="$apollo.queries.vendors.loading" :rules="[v => !!v || 'Vendor Name required']">
                                <template v-slot:item="{item}">
                                    <v-list-item-avatar>
                                        <img :src="imgWpx(item.profileImage, 200)" v-if="item.profileImage" @error="item.profileImage = null">
                                        <v-icon size="50" color="blue-grey lighten-4" v-else>mdi-account-circle</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content><v-list-item-title v-html="item.name"/></v-list-item-content>
                                    <v-list-item-action><v-list-item-action-text v-text="item.vendorCode"/></v-list-item-action>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="3" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Cartoons*</label>
                            <v-text-field type="number" outlined v-model="form.cartoons" class="mt-3" @keydown="preventExponent"
                                          :rules="[v => !!String(v).length || 'Cartoons required', v => (Number(v) > 0) || 'Invalid Cartoons',
                                                   v => Number.isInteger(Number(v)) || 'Invalid Cartoons']" placeholder="Enter Cartoons"/>
                        </v-col>
                        <v-col cols="3" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Per Cartoon Quantity*</label>
                            <v-text-field type="number" outlined v-model="form.qtyPerCartoon" class="mt-3" @keydown="preventExponent"
                                          :rules="[v => !!String(v).length || 'Per Cartoon Quantity required', v => (Number(v) > 0) || 'Invalid Quantity',
                                                   v => Number.isInteger(Number(v)) || 'Invalid Quantity']" placeholder="Enter Per Cartoon Quantity"/>
                        </v-col>
                      <v-col cols="3" class="pt-0">
                        <label class="text-uppercase grey--text font-weight-bold">Rate*</label>
                        <v-text-field type="number" outlined v-model="form.rate" class="mt-3" @keydown="preventExponent" placeholder="Enter Rate"
                                      :rules="[v => !!String(v).length || 'Rate required', v => (Number(v) > 0) || 'Invalid Rate']"/>
                      </v-col>
                        <v-col cols="3" class="pt-0 d-flex justify-space-between">
                          <div>
                            <label class="text-uppercase grey--text font-weight-bold">Total Amount</label>
                            <div class="text-h5 mt-6 black--text">{{totalAmount | currencyFilter}}</div>
                          </div>
                          <div>
                            <label class="text-uppercase grey--text font-weight-bold">Total Quantity</label>
                            <div class="text-h5 mt-6 black--text">{{totalQty}}</div>
                          </div>
                        </v-col>
                        <v-col cols="3" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Type of Product</label>
                            <v-radio-group class="mt-3" row dense v-model="form.productType">
                                <v-radio label="Regular" color="primary darken-4" value="REGULAR"/>
                                <v-radio label="China" color="primary darken-4" value="CHINA"/>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="3" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Transportation</label>
                            <v-text-field outlined v-model="form.transportation" class="mt-3"/>
                        </v-col>
                        <v-col cols="3" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Ordered Date*</label>
                            <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px" offset-y
                                     transition="scale-transition" v-model="orderedDateMenu">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field class=" mt-3" clearable outlined prepend-inner-icon="mdi-calendar-blank-outline"
                                                  readonly v-bind="attrs" v-model="orderedDateFormat" v-on="on" :rules="[v => !!v || 'Ordered Date required']"/>
                                </template>
                                <v-date-picker @input="orderedDateMenu = false" v-model="form.orderedDate"/>
                            </v-menu>
                        </v-col>
                        <v-col cols="3" class="pt-0">
                            <label class="text-uppercase grey--text font-weight-bold">Expected Delivery Date*</label>
                            <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px" offset-y
                                     transition="scale-transition" v-model="deliveryDateMenu">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field class=" mt-3" clearable outlined prepend-inner-icon="mdi-calendar-blank-outline"
                                                  readonly v-bind="attrs" v-model="deliveryDateFormat" v-on="on" :rules="[v => !!v || 'Expected Delivery Date required']"/>
                                </template>
                                <v-date-picker @input="deliveryDateMenu = false" v-model="form.deliveryDate" :min="form.orderedDate||moment().format('YYYY-MM-DD')"/>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-form>
              <v-divider class="mb-5"></v-divider>

                <div class="purchase-req-heading mb-5">Last Purchase Request from Party</div>
              <v-alert
                  outlined
                  color="success"
                  class="pl-8"
                  text
                  v-if="confirmedPurchaseRequest"
              >
                <v-row>
                  <v-col cols="3">
                    <v-avatar tile style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click="openGallery([{path: confirmedPurchaseRequest.Vendor.profileImage, type: 'IMAGE'}])" class="mr-6 avatar my-3" title="View Image">
                      <v-img v-if="confirmedPurchaseRequest.Vendor.profileImage" :alt="confirmedPurchaseRequest.Vendor.name" @error="confirmedPurchaseRequest.Vendor.profileImage = null"
                             :src="imgWpx(confirmedPurchaseRequest.Vendor.profileImage, 200)" >
                        <template v-slot:placeholder>
                          <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                          <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"/>
                        </template>
                      </v-img>
                      <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                    </v-avatar>
                    <span class="v-name ellipsis">
                                    <span class="text-body-1 font-weight-bold" :title="confirmedPurchaseRequest.Vendor.name">{{ confirmedPurchaseRequest.Vendor.name}}</span><br>
                                    <span :title="confirmedPurchaseRequest.Vendor.vendorCode" class="f-12 grey--text text--darken-1">{{confirmedPurchaseRequest.Vendor.vendorCode}}</span>
                                </span>
                  </v-col>
                  <v-col cols="3"><span class="text-caption">Ordered Date</span> <br> <span class="font-weight-bold">{{moment(confirmedPurchaseRequest.orderedDate).format('DD-MM-YYYY')}}</span></v-col>
                  <v-col cols="3"><span class="text-caption">Delivered Date</span> <br> <span class="font-weight-bold">{{confirmedPurchaseRequest.receivedDate?moment(confirmedPurchaseRequest.receivedDate).format('DD-MM-YYYY'): '-'}}</span></v-col>
                  <v-col cols="3"><span class="text-caption">Rate</span> <br> <span class="font-weight-bold">{{confirmedPurchaseRequest.rate | currencyFilter}}</span></v-col>
                </v-row>
              </v-alert>
                <div v-else bordered>No Result.</div>


                <div class="purchase-req-heading mt-10 mb-5" >Summary of Last 50 Purchase Request</div>
                <v-data-table class="bordered" :items="last50PurchaseRequests" :headers="headers">
                    <template v-slot:no-data>No Purchase Request Available</template>
                    <template v-slot:item.checkbox="{ item }">
                        <v-checkbox :input-value="[Constants.PRQStatuses.Confirmed, Constants.PRQStatuses.Received].includes(item.statusId)" readonly color="green"/>
                    </template>
                    <template v-slot:item.name="{ item: {Vendor} }">
                        <v-avatar tile style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click="openGallery([{path: Vendor.profileImage, type: 'IMAGE'}])" class="mr-6 avatar my-3" title="View Image">
                            <v-img v-if="Vendor.profileImage" :src="imgWpx(Vendor.profileImage, 200)" :alt="Vendor.name" @error="Vendor.profileImage = null">
                                <template v-slot:placeholder>
                                    <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                                    <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"/>
                                </template>
                            </v-img>
                            <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                        </v-avatar>
                        <span class="v-name ellipsis">
                                    <span :title="Vendor.name">{{ Vendor.name}}</span><br>
                                    <span :title="Vendor.vendorCode" class="f-12 grey--text text--darken-1">{{Vendor.vendorCode}}</span>
                                </span>
                    </template>
                    <template v-slot:item.orderedDate="{ item }">{{moment(item.orderedDate).format('DD MMM YYYY')}}</template>
                    <template v-slot:item.rate="{ item }">{{item.rate | currencyFilter}}</template>
                </v-data-table>
            </v-card-text>
            <v-card-actions class="pa-3">
                <v-spacer></v-spacer>
                <v-btn class="text-capitalize elevation-0 mr-2" @click="onCloseDialog">Cancel</v-btn>
                <v-btn class="primary px-3 text-capitalize" :loading="formLoading" dark @click="handleSubmit">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <Snackbar :toaster="toaster"/>
    <ConfirmationDialog :confirmationMessage="confirm.message" @confirm="confirm.method" @close="confirm.closeMethod"
                        v-if="confirm.enable"/>
    <gallery id="gallery-p-r-form" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
</div>
</template>

<script>
import Constants from "../../../Constants/Constants";
import moment from 'moment';
import Snackbar from "../../../components/Common/Snackbar";
import {
    GET_PRODUCT_AND_VENDOR_BY_THEIR_ID,
    GET_PURCHASE_REQUEST_BY_ID,
    GET_PURCHASE_REQUEST_BY_PRODUCT_ID
} from "../../../graphql/queries/PurchaseRequest";
import {CREATE_UPDATE_PURCHASE_REQUEST} from "../../../graphql/mutations/PurchaseRequest";
import searchVendor from '../../../mixins/searchVendor';
import searchProduct from '../../../mixins/searchProduct';
import gallery from '../../../mixins/gallery';
import {preventExponent} from "../../../util/helpers";
import ConfirmationDialog from "../../../components/Common/ConfirmationDialog";
let user = JSON.parse(localStorage.user);
let form = { productId:'', vendorId:'', statusId: Constants.PRQStatuses.Pending, cartoons:'', qtyPerCartoon:'',
             rate:'', productType:'REGULAR', transportation:'', orderedDate:moment().format('YYYY-MM-DD'),
             requestedDate:moment().format('YYYY-MM-DD'), deliveryDate:moment().add(1, 'days').format('YYYY-MM-DD'), createdBy:user.id, updatedBy:user.id };
export default {
    name: "PurchaseRequestForm",
    components: {ConfirmationDialog, Snackbar},
    props: ['dialog', 'id'],
    mixins: [searchVendor, searchProduct, gallery],
    apollo: {
        PurchaseRequest: {
            query: GET_PURCHASE_REQUEST_BY_ID,          //Always fetch createdBy to override default
            fetchPolicy: 'network-only',
            skip () {return !this.id},
            variables(){ return{ id: this.id } },
            result ({data}) {
                Object.copyExistingKeys(this.form = {...form, id:''}, data.PurchaseRequest[0]);
                this.getProductAndVendorByTheirId(this.form.productId, this.form.vendorId)
            },
        },
    },
    data(){
        return{
            moment, Constants,
            form: {...form},
            formLoading: false,
            toaster: {enable: false},
            confirm: {enable: false},
            orderedDateMenu: false,
            deliveryDateMenu: false,
            confirmedPurchaseRequest: null,
            last50PurchaseRequests: [],
            headers: [
                {text: '', value: 'checkbox'}, {text: 'VENDOR NAME', value: 'name'},
                {text: 'ORDERED DATE', value: 'orderedDate'}, {text: 'RATE PER PIECE', value: 'rate'},
                {text: 'CARTOONS', value: 'cartoons'}, {text: 'PIECE PER CARTOON', value: 'qtyPerCartoon'}
            ],
            preventExponent
        }
    },
    computed:{
        totalQty(){
            return this.form.qtyPerCartoon * this.form.cartoons;
        },
        totalAmount (){
            return this.totalQty * this.form.rate;
        },
        orderedDateFormat: {
            get () { return this.form.orderedDate ? moment(this.form.orderedDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : null },
            set () { this.form.orderedDate = null }
        },
        deliveryDateFormat: {
            get () { return this.form.deliveryDate ? moment(this.form.deliveryDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : null },
            set () { this.form.deliveryDate = null }
        },
    },
    methods:{
        async getProductAndVendorByTheirId(productId, vendorId){
            let response = await this.$apollo.query({
                query: GET_PRODUCT_AND_VENDOR_BY_THEIR_ID,
                fetchPolicy: 'network-only',
                variables:{ productId, vendorId }
            });
            this.products = response.data.Products;
            this.selectedProduct = response.data.Products[0];
            this.vendors = response.data.Vendors;
            this.selectedVendor = response.data.Vendors[0];
            this.getPurchaseRequestByProductId(productId);
        },
        onChangeProduct(val){
            this.form.productId = val?.id || '';
            this.form.qtyPerCartoon = val?.cartonQty || '';
            /* this.form.rate = val?.purchasePrice || ''; */
            if(val) this.getPurchaseRequestByProductId(val.id);
            else {
                this.confirmedPurchaseRequest = null;
                this.last50PurchaseRequests = [];
            }
        },
        onchangeVendor(val){
            this.form.vendorId = val?.id || '' ;
            this.form.transportation = val?.transportation || '';
        },
        async getPurchaseRequestByProductId(productId){
            let response = await this.$apollo.query({
                query: GET_PURCHASE_REQUEST_BY_PRODUCT_ID,
                fetchPolicy: 'network-only',
                variables:{ productId }
            });
            this.confirmedPurchaseRequest = response.data.confirmedPurchaseRequest[0] || null;
            this.last50PurchaseRequests = response.data.PurchaseRequest;
        },
        handleSubmit(){
            if(this.$refs.form.validate()) this.savePurchaseRequest()
        },
        async savePurchaseRequest(){
            this.formLoading = true;
            let response = await this.$apollo.mutate({
                mutation: CREATE_UPDATE_PURCHASE_REQUEST,
                variables: {
                    purchaseRequest: { ...this.form, totalQty:this.totalQty, totalAmount:this.totalAmount },
                    updateColumns: [...Object.keys(this.form), 'totalQty', 'totalAmount'],
                }
            });
            if(response.data){
                this.formLoading = false;
                this.toaster = {enable:true, color:'green', message: `Purchase Request saved Successfully`};
                this.closeDialog();
            }
        },
        onCloseDialog(){
            this.confirm = {enable:true, message:'Are you sure want to close Purchase Request Form?',
                            method:this.closeDialog, closeMethod:this.closeConfirmPopup};
        },
        closeConfirmPopup(){
            this.confirm = {enable: false};
        },
        closeDialog(){
            this.$refs.form.resetValidation();
            this.form = {...form};
            this.selectedProduct = null;
            this.selectedVendor = null;
            this.confirmedPurchaseRequest = null;
            this.last50PurchaseRequests = [];
            this.closeConfirmPopup();
            this.$emit('update:dialog', false);
            this.$emit('update:id', null);
        }
    }
}
</script>

<style scoped>
.read-only-value{
    padding: 30px 0 0 10px;
    font-size: 16px;
    color: rgba(0,0,0,.87);
}
.requested-date{
    font-size: 16px;
    margin-right: 24px;
}
.requested-date span{
    font-weight: 600;
}
.bordered{
    border: 1px solid #e0e0e0;
    padding: 10px;
}
.purchase-req-heading{
    font-size: 16px;
    font-weight: 600;
    color: black;
    margin: 0 0 4px 0;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /*cursor: default;*/
}
.v-name{
    display: inline-block;
    vertical-align: middle;
    width: 150px;
    max-width: 150px;
}
</style>
